import { render, staticRenderFns } from "./categoryDetail.vue?vue&type=template&id=168ec138&scoped=true&"
import script from "./categoryDetail.vue?vue&type=script&lang=js&"
export * from "./categoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./categoryDetail.vue?vue&type=style&index=0&id=168ec138&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168ec138",
  null
  
)

export default component.exports